import React, { useEffect, useState } from 'react';
import 'regenerator-runtime/runtime';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CohortTableToolbar from "./TableToolbar";
import CohortTableHead from "./TableHead";
import ParticipantRow from "./ParticipantRow";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AggregationView from "../AggregationView";
import Switch from '@mui/material/Switch';
import { FormControlLabel, FormGroup, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import {makeStyles} from "@mui/styles";
import CaButton from "../../../../gpap-lib/components/shared-components/CaButton";
import TableRowNoData from '../../customVariantTable/TableRowNoData';
import { renderToStringAlt } from '../../../../scenes/instand/reports/create-report/shared-components/renderToString';

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        fontSize: "1em"
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
        fontSize: ".9em"
    },
    tableCell:{
        fontSize: ".9em",
        color: "blue"
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0, position: 'absolute',
        top: 20,
        width: 1,
    },
    searchField: {
        margin: theme.spacing(1),
        width: '100%',
    },
}));

export default function MUITable(props) {

    const default_rows_pp = 5;
    const classes = useStyles();
    const participant_id = "report_id";
    const [rows, setRows] = useState([]);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('report_id');
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0); // this is the loaded data page;
    const [realPageNumber, setRealPageNumber] = useState(0);

    let row_size = (props.rows!== undefined) ? props.rows.length/default_rows_pp : 0;
    let row_length= (props.rows!== undefined) ? props.rows.length : 0;
    const [totalPagesLoaded, setTotalPagesLoaded] = useState(row_size);
    const [totalPages, setTotalPages] = useState(Math.ceil(props.total_participants/default_rows_pp));
    const [dense, setDense] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(default_rows_pp);
    const [totalRows, setTotalRows] = useState(props.total_participants);
    const [totalObj, setTotalForQuery] = useState({query: 0, total: 0});
    const [showAffectedOnly, setShowAffectedOnly] = useState(false);
    const [numAffected, setNumAffected] = useState(0);


    const [state, setState] = useState({
        showCharts: false
    });

    const [searchFilters, setSearchFilters] = useState({});

    useEffect(() => {
        setSelected([]);
    }, [props.query_id]);

    useEffect(() => {
        setPage(0);
        let rows = (props.rows === undefined) ? []: props.rows;
        let row_size = (props.rows!== undefined) ? props.rows.length/default_rows_pp : 0;
        const newRows = showAffectedOnly
            ? props.rows.filter((row) => row.affectedStatus === "Affected")
            : props.rows;
        setRows(newRows);

        setTotalPagesLoaded(row_size);
        setRealPageNumber(row_size*(props.table_page-1)+1);
        setTotalRows(props.total_participants);
        setTotalPages(Math.ceil(props.total_participants/default_rows_pp))

        if(props.total!==0 && props.total!== undefined){
                if(props.query_id!== totalObj.query_id){
                    // change the total for the query_id (case cohortapp or search across all
                    setTotalForQuery({
                        query_id: props.query_id,
                        total: props.total
                    });
                }

        }



    }, [props.rows, showAffectedOnly]); // Only re-run the effect if count changes


    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    useEffect(() => {
        if (props.rows) {
            const allAffected = props.rows.filter(r => r.affectedStatus === "Affected");
            setNumAffected(allAffected.length);
        }
    }, [props.rows]);

    const handleAffectedToggle = (event) => {
        const checked = event.target.checked;
        setShowAffectedOnly(checked);
        let filteredRows = props.rows || [];
      
        if (checked) {
            filteredRows = filteredRows.filter(r => r.affectedStatus === 'Affected');
        }
      
      
        setRows(filteredRows);
      
        if ((props.experiments?.length ?? 0) === 0) {
            const participantIDs = filteredRows.map(r => r[participant_id]);
            const isSelected = selected.length !== 0;
            const isAffected = checked;
            props.selectParticipants(participantIDs, true, isAffected, isSelected, false);
        }
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map((n) => n[participant_id]);
            setSelected(newSelecteds);
            props.selectParticipants(newSelecteds, true, showAffectedOnly, true, false);
            return;
        }
        setSelected([]);
        props.selectParticipants([], true, showAffectedOnly, false, false);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            //newSelected = newSelected.concat(selected, name);
            newSelected.push(name)
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
        props.selectParticipants(newSelected, true, showAffectedOnly, newSelected.length > 0, false);
    };


    const handleChangePage = (event, newPage) => {
        if(newPage >= totalPagesLoaded){
           props.loadMore(true)  // true -> forward
        }
        else if(newPage<=0 && props.table_page!==1){
            props.loadMore(false)// false -> go back
        }
        else{
            setPage(newPage);
            (newPage>page) ? setRealPageNumber(realPageNumber+ (newPage-page)) : setRealPageNumber(realPageNumber-(newPage-page))
        }
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setTotalRows(props.total_participants);
        setTotalPages(Math.ceil(props.total_participants/event.target.value));

        setTotalPagesLoaded(props.rows / (parseInt(event.target.value, 10)));
        setPage(0);
    };


    const resetToSearchAll = () => {

        setSelected([]);
        props.selectParticipants("ALL_SAMPLES", true, showAffectedOnly, false, false);

    }

    const isSelected = (name) => selected.indexOf(name) !== -1;

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, row_length - page * rowsPerPage);

    let BACK_DISABLED = (realPageNumber === 1 );

    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };

    const getText = () => ({ from, to, count }) => {

        return `(page ${realPageNumber} of total ${totalPages}). 
        Displaying participants ${from}-${to} of total ${props.total_participants}`;

    }

    const handleSearchChange = (columnId, value) => {
        setSearchFilters(prev => ({
            ...prev,
            [columnId]: value
        }));
        // Reset to first page when search changes
        setPage(0);
    };

    const filterRows = (rows) => {
        if (!rows) return [];
        
        return rows.filter(row => {
            return Object.entries(searchFilters).every(([columnId, searchValue]) => {
                if (!searchValue) return true;
                
                // Handle exact matches for select fields
                if (columnId === 'affectedStatus' || columnId === 'solved') {
                    return row[columnId] === searchValue;
                }
                
                // Handle special cases for different column types
                if (columnId === 'features') {
                    const features = row[columnId] || [];
                    const featureNames = features
                        .filter(f => f?.observed === true)
                        .map(term => term?.name || '')
                        .join(', ')
                        .toLowerCase();
                    return featureNames.includes(searchValue.toLowerCase());
                }
                
                if (columnId === 'diagnosis') {
                    const diagnoses = row[columnId] || [];
                    const diagnosisNames = diagnoses
                        .map(diagnosis => diagnosis?.ordo?.name || '')
                        .join(', ')
                        .toLowerCase();
                    return diagnosisNames.includes(searchValue.toLowerCase());
                }
                
                // Handle array values
                if (Array.isArray(row[columnId])) {
                    return row[columnId].some(value => 
                        String(value).toLowerCase().includes(searchValue.toLowerCase())
                    );
                }
                
                // Numeric columns: filter by >= (greater than or equal to)
                const numericFilterColumns = ['n_snv', 'n_cnv'];
                if (numericFilterColumns.includes(columnId)) {
                    const threshold = parseFloat(searchValue);
                    if (isNaN(threshold)) return true;
                    const cellNum = parseFloat(row[columnId]) || 0;
                    return cellNum >= threshold;
                }

                // Handle regular string/number values
                const cellValue = String(row[columnId] || '').toLowerCase();
                return cellValue.includes(searchValue.toLowerCase());
            });
        });
    };

    const getSelectedSnvTotal = () => {
        if (!Array.isArray(selected) || selected.length === 0) return 0;
        return rows
            .filter((row) => selected.includes(row[participant_id]))
            .reduce((sum, row) => sum + (Number(row.n_snv) || 0), 0);
    };

    const showTable = () => {
        let linksParticipants = props.participantsIDs.toString();
        const filteredRows = filterRows(rows);

        return <React.Fragment>
            <CohortTableToolbar
                loadVariants={() => props.selectParticipants(selected, true, showAffectedOnly, selected.length > 0, true, { snvTotal: getSelectedSnvTotal() })}
                sendSelected={false}
                selected={selected}
                numSelected={selected.length}
                total_participants={props.total_participants}/>
            <Box sx={{ px: 2, py: 1 }}>
                <Typography variant="caption" color="text.secondary">
                    Note: The filtering is only applied to the currently loaded data in the table. The search does not look beyond the first 1000 participants.
                </Typography>
            </Box>
            <TableContainer>
                <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    size={dense ? 'small' : 'medium'}
                    aria-label="enhanced table">
                    <CohortTableHead
                        classes={classes}
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onSelectAllClick={handleSelectAllClick}
                        onRequestSort={handleRequestSort}
                        rowCount={row_length}
                        searchFilters={searchFilters}
                        onSearchChange={handleSearchChange}
                    />
                    <TableBody>
                        {filteredRows.length > 0 
                        ? <>    {stableSort(filteredRows, getComparator(order, orderBy))
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                                const isItemSelected = isSelected(row[participant_id]);
                                const labelId = `enhanced-table-checkbox-${index}`;
                                return <ParticipantRow
                                    participant_id={participant_id}
                                    handleClick={handleClick}
                                    isItemSelected={isItemSelected}
                                    labelId={labelId}
                                    row={row}
                                    index={index}
                                    experiments={props.experiments.filter(d => d.Participant_ID === row[participant_id])}
                                />
                            })}
                        {emptyRows > 0 && (
                            <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                                <TableCell colSpan={6} />
                            </TableRow>
                        )}  </>
                        : <TableRowNoData  
                         message={ (linksParticipants == "") 
                         ? renderToStringAlt("No matching participants found."): renderToStringAlt("Participants can't be displayed.")}
                         submessage={(linksParticipants === "") ? "Try adjusting your search filters." : "The participants associated to the variants requested can't be displayed. Please check these participants in PhenoStore: " + linksParticipants}
                         colSpan={5}
                        />
                        }    
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                slotProps={{
                    backButton: { disabled: BACK_DISABLED },
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelDisplayedRows={getText()}
            />
        </React.Fragment>
    }

    const showView = () => {

        return (state.showCharts) ? <AggregationView initData={props.aggregations}/> : showTable()

    }
    const renderAffectedSwitch = () => {
        return (
            <FormControlLabel
                control={
                    <Switch
                        size="small"
                        checked={showAffectedOnly}
                        onChange={handleAffectedToggle}
                        color="primary"
                        name="showAffectedOnly"
                    />
                }
                label={showAffectedOnly 
                    ? `Show only Affected Participants (${numAffected})`
                    : "Show only Affected Participants"}
            />
        );
    };

    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Box p={1}> <FormGroup row>
                    <FormControlLabel
                        control={
                            <Switch
                                size="small"
                                checked={state.showCharts}
                                onChange={handleChange}
                                color="primary"
                                name="showCharts"
                            />
                        }
                        label="Show Participant Summary"
                    />
                     {renderAffectedSwitch()}
                </FormGroup>
                </Box>
                {(
                     (props.total !== undefined && totalObj.total > props.total))
                    ? <CaButton
                        text={"Reset Gene and Participant Selection"}
                        variant="contained"
                                   onClick={ () => resetToSearchAll() }
                                   startIcon={<ArrowBackIcon/>}
                    />
                    : null}
                {(props.rows!== undefined)
                    ? showView()
                    : null
                }

            </Paper>
        </div>
    );
}